export default {
  menu: '公司主题管理',
  label: {
    theme: '定制公司主题',
    name: '名称',
    link: '链接',
    headerSetting: '页眉配置',
    footerSetting: '页脚配置',
    commonSetting: '通用配置',
    personalHomePCSetting: '候选人个人主页设置（电脑端）',
    personalHomeMobileSetting: '候选人个人主页设置（手机端）',
    loginSetting: '登录页配置',
    companyDetailSetting: '导航栏配置',
    customColor: '主题颜色',
    showCompanyLogo: '定制页眉Logo',
    logoImage: 'Logo',
    faviconImage: '浏览器标签页Logo',
    logoPosition: 'Logo位置',
    showCompanyName: '展示公司名称',
    logoWidth: 'Logo宽度',
    backgroundColor: '背景色',
    fontColor: '字体颜色',
    phoneIcon: '展示菁客400服务电话',
    userMenu: '用户菜单配置',
    height: '页眉高度',
    content: '导航',
    customFont: '字体',
    navigationLinkPosition: '导航栏位置',
    userMenuBackgroundColor: '背景色',
    userMenuFontColor: '字体颜色',
    pageBackgroundColor: '背景色',
    showContainerLogo: '展示公司Logo',
    followCustomColor: '跟随主题色',
    customMenuList: '菜单配置',
    languagePosition: '语言切换按钮',
    left: '左侧',
    center: '居中',
    right: '右侧',
    homePage: '主页',
    infoPage: '信息页',
    jobListPage: '职位列表页',
    menuGroupName: '菜单名称',
    onlyEmployee: '仅员工可见',
    bindOrChangeMobile: '绑定手机/更改手机',
    bindOrChangeEmail: '绑定邮箱/更改邮箱',
    fixedHeader: '浮动固定栏',
    enName: '英文名称',
    cnName: '中文名称'
  },
  btn: {
    addNewLine: '添加新的行',
    reuploadFont: '重新上传',
    uploadFont: '上传字体'
  },
  message: {
    fieldIsRequired: '该字段为必填。'
  }
}
